// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FileWordTwoToneSvg from "@fishx/icons-svg/es/asn/FileWordTwoTone";
import FishxIcon from '../components/FishxIcon';

var FileWordTwoTone = function FileWordTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: FileWordTwoToneSvg
  }));
};

FileWordTwoTone.displayName = 'FileWordTwoTone';
export default React.forwardRef(FileWordTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/FileWordTwoTone.js
// module id = 2759
// module chunks = 0